 <!-- Display status message -->
 <div>
  <h4>{{displayStatus}}</h4>
</div>